import { useEffect, useState } from "react";

function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const that = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) {
        func.apply(that, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(that, args);
    }
  };
}

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return debouncedValue;
};

export default debounce;
